<tt-page>
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListGuards"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListGuards" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
